import React, { useState } from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { createDownloadLink } from '../../utils/utils';
import ViewPDF from '../pdfviewer/viewpdf';
import PropTypes from 'prop-types';
import './reportitem.component.css';

const ReportItem = ({reportData}) => {
    const [openViewer, setOpenViewer] = useState(false);
    const matches = reportData.report.match(/\.([^.]+)$/);
    const imgIcon = matches[1] !== 'pdf' ? <ImageIcon /> : <PictureAsPdfIcon />;
    const toggleReportViewer = (toggle) => () => {
        setOpenViewer(toggle);
    };
    const downloadReport = () => {
        createDownloadLink(reportData.report);
    };
    const viewImage = (
        <div className='img-report-container'>
            <img src={reportData.report} alt="report_file" />
        </div>
    );
    const viewPdf = matches[1] === 'pdf' ? <ViewPDF file={reportData.report} /> : viewImage;
    const pdfViewer = openViewer && (
        <Dialog open={openViewer} maxWidth='md' fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>View Report</div>
                <IconButton size='small' onClick={toggleReportViewer(false)}>
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {viewPdf}
            </DialogContent>
        </Dialog>
    );

    const hasReportUI = Object.hasOwn(reportData, 'isReport') && (
        <Typography variant="subtitle2" gutterBottom>
            For report: {reportData?.reportData?.name || 'N/A'}
        </Typography>
    );

    return (
        <div className='report-item'>
            <div className='img-container'>{imgIcon}</div>
            <Typography variant="h6" gutterBottom style={{textTransform: 'capitalize'}} className='text-ellipsis'>
                {reportData.name}
            </Typography>
            {hasReportUI}
            {pdfViewer}
            <div className='flex-gap'>
                <Button color="primary" variant="contained" onClick={toggleReportViewer(true)}> View </Button>
                <Button color="primary" variant="contained" onClick={downloadReport}> Download </Button>
            </div>
        </div>
    );
};

export default ReportItem;

ReportItem.propTypes = {
    reportData: PropTypes.object.isRequired
};